import { useRef, useState } from 'react';
import { useNavigate } from 'react-router';

import { incidentDetailRoute } from '@/features/shared/routes';
import { createIncident } from './emsCommands';
import type { CallWithIncidentId } from './incidentListSelectors';
import { CallNotificationListComponentItem } from './CallNotificationListComponentItem';

export type CallNotificationListComponentProps = {
  callNotifications: readonly CallWithIncidentId[];
};

export function CallNotificationListComponent({ callNotifications }: CallNotificationListComponentProps) {
  const navigate = useNavigate();
  const [requestedIncidentId] = useState(() => crypto.randomUUID());
  const createIncidentInProgressRef = useRef(false);

  const createNewIncident = async (item: CallWithIncidentId) => {
    if (createIncidentInProgressRef.current) {
      return;
    }

    createIncidentInProgressRef.current = true;
    try {
      await createIncident(requestedIncidentId, [item.callNotification.callId]);
      void navigate(incidentDetailRoute(requestedIncidentId));
    } finally {
      createIncidentInProgressRef.current = false;
    }
  };

  return (
    <div className="call-notifications-list">
      {callNotifications.map((item) => (
        <CallNotificationListComponentItem
          key={item.callNotification.id}
          item={item}
          onCreateNewIncident={createNewIncident}
        />
      ))}
    </div>
  );
}
